import { fetchDataFailureMyTasks, fetchDataSuccessMyTasks } from "./actions";
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import { FetchRequestAction } from "../../types/strapiMyTasks";
import { fetchStrapiData } from '../../api/api';

const extractStrapiData = (response: any) => {
  if (response && response.data && response.data.data) {
    return response.data.data;
  }
  if (response && response.data) {
    return response.data;
  }
  return [];
};

export function* fetchDataSagaMyTasks(action: FetchRequestAction) {
  const { modelName, params } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(fetchStrapiData, modelName, params);
    const extractedData = extractStrapiData(response);
    const paginationInfo = response.data?.meta?.pagination;
    yield put(fetchDataSuccessMyTasks(modelName, extractedData, paginationInfo));
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(fetchDataFailureMyTasks(modelName, errorMessage));
  }
}
